import { Component, Input } from '@angular/core';
import { BreadcrumbElement } from '@planone/shared/ui-elements';

@Component({
  selector: 'bau365-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  @Input() breadcrumbElements: BreadcrumbElement[] | undefined | null;
  @Input() breadcrumbClickable = true;
}
